<template>
  <label class="checkbox" :class="{ disabled }">
    <!-- 실제 checkbox 가리기-->
    <input type="checkbox" :checked="modelValue" :disabled="disabled" @change="onChange" />

    <span class="checkbox-ui">
      <!-- <IconCheck v-if="modelValue" /> -->
      <IconCheck></IconCheck>
    </span>

    <p v-if="$slots.default">
      <slot />
    </p>
  </label>
</template>

<script setup lang="ts">
import IconCheck from '@/components/icons/IconCheck.vue';

defineProps<{
  modelValue: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>
